export default __webpack_public_path__ + "static/media/intouch.475c5799.png";